import React from 'react';

interface Props {
    saveStatus: 'unsaved' | 'saved' | 'saving';
}

const saveMap = {
    saving: 'Saving...',
    unsaved: 'Unsaved',
    saved: 'Saved',
};

export const SaveStatus: React.FC<Props> = ({saveStatus}) => {
    return (
        <div className="absolute bottom-0 left-0 right-0 flex h-12 items-center justify-center rounded-bl-2xl rounded-br-2xl border-t border-t-zinc-700 bg-neutral-900/95">
            <span className="text-lg font-bold text-neutral-300">{saveMap[saveStatus]}</span>
        </div>
    );
};
